module.exports = __webpack_public_path__ + "static/media/spring-boot.9e4096e1.png";